import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import ButtonLink from 'components/ButtonLink'
import ROUTES from 'config/routes.json'
import content from 'prismic-translates/page-my-games.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

export default function Placeholder() {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <h6 className={cx('mt-typography-h6', classes.title)}>{t('title')}</h6>
        <span className={cx('mt-typography-caption', classes.caption)}>{t(`${process.env.BRAND_NAME}_text_msg`)}</span>
        <ButtonLink href={ROUTES.GAMES_SLOTS} variant='contained' className={classes.btnLink}>
          {t('back_to_slot_games')}
        </ButtonLink>
      </div>
    </div>
  )
}
